'use strict'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import moment from 'moment'
import 'moment/locale/pt-br';
import dotenv from 'dotenv'
import translate from '../src/plugins/translate'
import translateJob from './app/translate/translateJob'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import VueMask from 'v-mask'
import Money from 'v-money'

dotenv.config()

// filters

Vue.filter('translate', translate)
Vue.use(Money)
moment.locale('pt-br')
Vue.prototype.moment = moment


// jobs 

translateJob()


// Components

Vue.use(ElementUI)
Vue.use(Vuesax)
Vue.use(VueMask)


new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
}).$mount('#app')